import { defineComponent as _defineComponent } from 'vue'
import '@/components/article-editor/EditorNavbar/SmartContentLoader/SmartContentLoader.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'SmartContentLoader',
  props: {
    headTitle: null,
    readyTitle: null,
    loadingTitle: null,
    icon: null,
    percent: null,
    isShowLabel: { type: Boolean },
    isShowReady: { type: Boolean },
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})